import api from "./Api";

class AgenciaBoletoService {
  GetAgenciaBoleto(payload) {
    return api.get("/v1/agenciaboleto/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAgenciaBoleto(payload) {
    return api.post("/v1/agenciaboleto/", payload).then((response) => {
      return response.data;
    });
  }

  PutAgenciaBoleto(payload) {
    return api.put("/v1/agenciaboleto/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAgenciaBoleto(payload) {
    return api.delete("/v1/agenciaboleto/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAgenciaBoletoOData(payload) {
    return api.get("/OData/AgenciaBoleto" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AgenciaBoletoService();
